import { render, staticRenderFns } from "./hdraces-bets.vue?vue&type=template&id=1fabb44b&scoped=true"
import script from "./hdraces-bets.vue?vue&type=script&lang=js"
export * from "./hdraces-bets.vue?vue&type=script&lang=js"
import style0 from "./hdraces-bets.vue?vue&type=style&index=0&id=1fabb44b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fabb44b",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/hdraces-bets.vue
// module id = CaA5
// module chunks = 0